import { StateEffect, StateField } from '@codemirror/state';
import { EditorView, showTooltip, Tooltip } from '@codemirror/view';

// Define state effects for showing/hiding the tooltip
const setTooltip = StateEffect.define<Tooltip | null>();

const errorTooltipField = StateField.define<Tooltip | null>({
  create() {
    return null;
  },
  update(tooltip, tr) {
    if (tr.docChanged) {
      return null;
    }

    for (const effect of tr.effects) {
      if (effect.is(setTooltip)) {
        return effect.value;
      }
    }
    return tooltip;
  },
  provide: (field) => showTooltip.from(field, (tooltip) => tooltip),
});

const errorTooltipBaseTheme = EditorView.baseTheme({
  '.cm-tooltip.cm-error-tooltip': {
    backgroundColor: 'rgba(177, 49, 49, 1)',
    color: 'white',
    border: 'none',
    padding: '2px 7px',
    borderRadius: '4px',
    '& .cm-tooltip-arrow:before': {
      borderTopColor: 'rgba(177, 49, 49, 1)',
    },
    '& .cm-tooltip-arrow:after': {
      borderTopColor: 'transparent',
    },
  },
});

export const lexQueryErrorTooltip = [errorTooltipBaseTheme, errorTooltipField];

export function showTooltipAtPosition(view: EditorView, position: number, content: string) {
  const tooltip: Tooltip = {
    pos: position,
    end: position,
    above: true,
    arrow: true,
    create() {
      const dom = document.createElement('div');
      dom.className = 'cm-error-tooltip';
      dom.textContent = content;
      return { dom };
    },
  };

  view.dispatch({
    effects: setTooltip.of(tooltip),
  });
}
